export enum EReimbursementModel {
    SALARY_BASED = 'SALARY_BASED',
    RVUS_BASED = 'RVUS_BASED',
    MIXED = 'MIXED',
    EMPTY = '',
}